import React, { useState } from 'react';
import {
  Button,
  Card,
  CardHeader,
  IconButton,
  Modal,
  TextField,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import { AccountForm } from '../../domain/Userbase/Account';
import * as api from '../../api/userbase';
import { Success, useDispatch } from '../../store/provider';

type Props = {
  reloadList: () => void;
};

export const New: React.FC<Props> = (props) => {
  const classes = useStyles();
  const [apper, setApper] = useState(false);
  const [newAccount, setNewAccount] = useState({
    accountId: 0,
    loginId: '',
    email: '',
    familyName: '',
    givenName: '',
    beginDate: '',
    endDate: '',
    forceDisable: false,
    deleted: false,
    denyDelete: false,
  } as AccountForm);
  const dispatch = useDispatch();

  const handleNewAppear = () => {
    setApper(true);
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    e.persist();

    setNewAccount((prevState) => {
      switch (e.target.name) {
        case 'loginId':
          return { ...prevState, loginId: e.target.value };
        case 'email':
          return { ...prevState, email: e.target.value };
        case 'familyName':
          return { ...prevState, familyName: e.target.value };
        case 'givenName':
          return { ...prevState, givenName: e.target.value };
        case 'beginDate':
          return { ...prevState, beginDate: e.target.value };
        case 'endDate':
          return { ...prevState, endDate: e.target.value };

        default:
          return prevState;
      }
    });
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    await api.accountAdd(newAccount);
    Success(dispatch, 'created');
    setApper(false);
    props.reloadList();
  };

  const handleClose = () => {
    setApper(false);
  };

  let form = <div />;
  if (apper) {
    form = (
      <Modal
        open={true}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
      >
        <Card className={classes.paper}>
          <CardHeader
            style={{ background: '#eee' }}
            action={
              <div aria-label="settings">
                <IconButton onClick={handleClose}>
                  <CloseIcon />
                </IconButton>
              </div>
            }
          />
          <form onSubmit={handleSubmit} className={classes.form}>
            <TextField
              name="loginId"
              label="LoginId"
              fullWidth
              onChange={handleChange}
            />
            <TextField
              name="email"
              label="Email"
              fullWidth
              onChange={handleChange}
            />
            <TextField
              name="familyName"
              label="Familyname"
              fullWidth
              onChange={handleChange}
            />
            <TextField
              name="givenName"
              label="GivenName"
              fullWidth
              onChange={handleChange}
            />
            <TextField
              name="beginDate"
              label="BeginDate"
              fullWidth
              onChange={handleChange}
            />
            <TextField
              name="endDate"
              label="EndDate"
              fullWidth
              onChange={handleChange}
            />
            <Button type="submit" variant="contained">
              Submit
            </Button>
          </form>
        </Card>
      </Modal>
    );
  }

  return (
    <div>
      <Button variant="contained" onClick={handleNewAppear}>
        New
      </Button>
      {form}
    </div>
  );
};

const dialogWidth = 600;
const useStyles = makeStyles((theme) =>
  createStyles({
    paper: {
      position: 'absolute',
      width: dialogWidth,
      backgroundColor: theme.palette.background.paper,
      border: '2px solid #000',
      top: '10%',
      left: 'calc(50% - 300px)',
    },
    form: {
      padding: theme.spacing(2, 4, 3),
    },
  })
);
